import type { AuthUser, VerifyLoginOtpResponse } from '../types';

export function toAuthUser(data: VerifyLoginOtpResponse): AuthUser {
  return {
    id: data.user.id,
    email: data.user.email,
    name: data.user.name,
    phone: null,
    avatar: null,
    office: data.user.office ?? null,
    roles: data.user.roles ?? [],
    permissions: data.user.permissions ?? []
  };
}
